module.exports = __webpack_public_path__ + "img/newsImg11-12.2ee52858.png";